import MetricBadge from "../MetricBadge"
import { formatNumber } from "helpers/fuelUsage_helpers"

/**
 * Table cell presenting the odometer reading and the tank-to-tank derived
 * metrics for a fuel-usage row: distance run since the previous refuel and the
 * fuel efficiency achieved.
 *
 * Metrics depend on {@link enrichFuelUsages} having populated `data.metrics`.
 */
const FuelEfficiencyCell = ({ data = {} }) => {
  const { mileage } = data ?? {}
  const { distance, efficiency, hasBaseline } = data?.metrics ?? {}

  return (
    <div className="d-flex flex-column gap-1" style={{ minWidth: 190 }}>
      <MetricBadge
        icon="bx-tachometer"
        label="Odometer"
        value={mileage != null ? `${formatNumber(mileage)} km` : "-"}
        color="primary"
        title="Vehicle mileage recorded at this refuel"
      />

      {hasBaseline && distance != null ? (
        <MetricBadge
          icon="bx-map"
          label="Run"
          value={`${formatNumber(distance)} km`}
          color={distance < 0 ? "danger" : "info"}
          title="Distance run since the previous refuel of this vehicle"
        />
      ) : (
        <span className="text-muted small fst-italic">
          No prior refuel in view
        </span>
      )}

      {efficiency != null && (
        <MetricBadge
          icon="bx-trending-up"
          label="Efficiency"
          value={`${formatNumber(efficiency, 1)} km/L`}
          color={efficiency >= 10 ? "success" : "danger"}
          title="Distance covered per litre from the previous tank"
        />
      )}
    </div>
  )
}

export default FuelEfficiencyCell
